const Lock = ({ ...props }) => {
    return (
        <svg
            width="11px"
            height="15px"
            viewBox="0 0 11 15"
            version="1.1"
            {...props}
        >
            <g
                id="Checkout"
                stroke="none"
                strokeWidth="1"
                fill="none"
                fillRule="evenodd"
            >
                <g
                    id="Checkout---Review---Mobile"
                    transform="translate(-62.000000, -1708.000000)"
                    fill="currentColor"
                    fillRule="nonzero"
                >
                    <g
                        id="Continue-Button"
                        transform="translate(27.000000, 1586.000000)"
                    >
                        <g
                            id="Checkout-Footer"
                            transform="translate(0.000000, 107.000000)"
                        >
                            <g
                                id="Group"
                                transform="translate(35.000000, 13.000000)"
                            >
                                <g
                                    id="lock"
                                    transform="translate(0.000000, 2.000000)"
                                >
                                    <path
                                        d="M8.76811594,5.41237113 L8.76811594,3.17010309 C8.76811594,1.42209278 7.30205507,0 5.5,0 C3.69794493,0 2.23188406,1.42209278 2.23188406,3.17010309 L2.23188406,5.41237113 L0,5.41237113 L0,15 L11,15 L11,5.41237113 L8.76811594,5.41237113 Z M3.1884058,3.17010309 C3.1884058,1.93370103 4.22537101,0.927835052 5.5,0.927835052 C6.77462899,0.927835052 7.8115942,1.93370103 7.8115942,3.17010309 L7.8115942,5.41237113 L3.1884058,5.41237113 L3.1884058,3.17010309 Z M10.0434783,14.0721649 L0.956521739,14.0721649 L0.956521739,6.34020619 L10.0434783,6.34020619 L10.0434783,14.0721649 Z"
                                        id="Shape"
                                    />
                                    <path
                                        d="M4.89795918,10.1879756 L4.89795918,11.9473684 L6.24489796,11.9473684 L6.24489796,10.1879427 C6.77532245,10.0030961 7.14285714,9.6071933 7.14285714,9.14954358 C7.14285714,8.51568525 6.43791429,8 5.57142857,8 C4.70494286,8 4,8.51568525 4,9.14954358 C4,9.60722614 4.36753469,10.0031618 4.89795918,10.1879756 Z"
                                        id="Shape"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    )
}

export default Lock
